import {Show} from 'platform/foundation';

import {useGetCurrentUserInfoQuery} from '@dms/api/customer';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {catchUnhandledDataGridActions, DmsDataGrid} from '@dms/shared';

import {isNotNilOrEmpty} from 'shared/web';

import {MyProfileTemplate} from '../../components/MyProfileTemplate/MyProfileTemplate';

export function LoginHistory() {
  const {data: currentUser} = useGetCurrentUserInfoQuery();
  const currentUserId = currentUser?.id;

  return (
    <MyProfileTemplate
      data-testid={testIds.myProfile.loginHistory('header')}
      header={{
        title: i18n.t('entity.user.labels.loginHistory'),
        breadcrumbs: [
          {label: i18n.t('entity.user.labels.myProfile'), isCurrentPage: true},
          {label: i18n.t('entity.user.labels.loginHistory'), isCurrentPage: true},
        ],
      }}
    >
      <Show when={isNotNilOrEmpty(currentUserId) ? currentUserId : null}>
        {(userId) => (
          <DmsDataGrid
            gridCode="user-login-history"
            queryModifier={(filter) => ({...filter, userId})}
            actionCallback={({actionKey}) => catchUnhandledDataGridActions(actionKey)}
            data-testid={testIds.myProfile.loginHistory('datagrid')}
          />
        )}
      </Show>
    </MyProfileTemplate>
  );
}
